/* eslint-disable @typescript-eslint/ban-ts-comment */
import { ConnectOptions } from 'twilio-video';
import { isMobile, removeUndefineds } from '..';

const useConnectionOptions = () => {
    const connectionOptions: ConnectOptions = {
        bandwidthProfile: {
            video: {},
        },
        dominantSpeaker: true,
        networkQuality: { local: 1, remote: 1 },

        maxAudioBitrate: 0,
        preferredVideoCodecs: [{ codec: 'VP8' }],
        //@ts-ignore - Internal use only. This property is not exposed in type definitions.
        environment: process.env.REACT_APP_TWILIO_ENVIRONMENT,
    };

    if (isMobile && connectionOptions?.bandwidthProfile?.video) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        connectionOptions!.bandwidthProfile!.video!.maxSubscriptionBitrate = 2500000;
    }

    if (process.env.REACT_APP_TWILIO_ENVIRONMENT === 'dev') {
        //@ts-ignore - Internal use only. This property is not exposed in type definitions.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        connectionOptions!.wsServer = 'wss://us2.vss.dev.twilio.com/signaling';
    }

    return removeUndefineds(connectionOptions);
};

export default useConnectionOptions;
